"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualCoverPriceToPayCancellationOutput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var AnnualCoverPriceToPayCancellationOutput = /** @class */ (function (_super) {
    __extends(AnnualCoverPriceToPayCancellationOutput, _super);
    function AnnualCoverPriceToPayCancellationOutput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            partyLoaded: false,
            mainCardIdLoaded: false
        };
        return _this;
    }
    AnnualCoverPriceToPayCancellationOutput.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getProfile().subscribe(function (output) {
            _this.setState({
                party: output,
                partyLoaded: true
            });
        });
        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.interaction.agreementNumber, services_1.MAIN_ANNUAL_PAYMENT_CARD).subscribe(function (property) {
            _this.setState({
                mainCardId: property === null || property === void 0 ? void 0 : property.value,
                mainCardIdLoaded: true
            });
        });
    };
    AnnualCoverPriceToPayCancellationOutput.prototype.render = function () {
        var _a;
        var wording;
        var loading = !this.state.partyLoaded || !this.state.mainCardIdLoaded;
        if (!loading) {
            var paymentCard = (0, commonFunctions_1.findMainAnnualPaymentCard)(this.state.party, this.state.mainCardId);
            var last4Digits = (_a = paymentCard === null || paymentCard === void 0 ? void 0 : paymentCard.cardNumberObfuscated) === null || _a === void 0 ? void 0 : _a.slice(-4);
            wording = ((0, jsx_runtime_1.jsxs)("div", { className: "policy-cancellation-description", children: [services_1.resourcesHelper.THEME === "Britannia" ? ((0, jsx_runtime_1.jsxs)("h1", { className: "text-center text-blue-1", children: ["All ", (0, jsx_runtime_1.jsx)("span", { className: "last-word", children: "done" })] })) : ((0, jsx_runtime_1.jsx)("h1", { className: "text-center text-blue-1", children: "All done" })), (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: [(0, jsx_runtime_1.jsxs)("span", { className: "font-weight-semi-bold", children: ["Your car policy will end on ", (0, commonFunctions_1.convertDate)(this.props.interaction.headerInfo.endDate, "DD MMMM YYYY"), ", 23:59."] }), " You\u2019ll be covered until then."] }), this.renderPaymentWording(last4Digits), this.props.interaction.factors.cancellationFeeCharged &&
                        (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["If you take out a new car policy using this same account in the next 60 days, we\u2019ll refund the \u00A3", this.props.interaction.paymentDetails.instalmentPlan.instalmentPlanParameters.cancellationFee, " cancellation fee. (You must buy direct from us, not a price comparison site.)"] }), (0, jsx_runtime_1.jsx)("p", { className: "text-center", children: "We will send you Proof on No Claim Discount and an email confirmation when the policy is cancelled." }), (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["Thanks for being with ", services_1.resourcesHelper.PRODUCT, ". We hope you\u2019ll choose us again in the future."] })] }));
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!loading && wording, (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: loading })] }));
    };
    AnnualCoverPriceToPayCancellationOutput.prototype.renderPaymentWording = function (last4Digits) {
        var _a = this.props.interaction, paymentDetails = _a.paymentDetails, factors = _a.factors;
        var amount = (0, jsx_runtime_1.jsx)("span", { className: "font-weight-semi-bold", children: (0, commonFunctions_1.getAmountToDisplay)(factors.additionalPremium) });
        if (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.failed) {
            return ((0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["We couldn\u2019t collect ", amount, ". Please return to your dashboard to pay your outstanding balance."] }));
        }
        if (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.setteled) {
            return ((0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["We\u2019ve collected ", amount, " from your card", last4Digits && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [" ending ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-semi-bold", children: last4Digits })] }), "."] }));
        }
        return (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["Your payment of ", amount, " is awaiting confirmation."] });
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualCoverPriceToPayCancellationOutput.prototype, "customerPortalService", void 0);
    return AnnualCoverPriceToPayCancellationOutput;
}(plugin_journey_1.WidgetBase));
exports.AnnualCoverPriceToPayCancellationOutput = AnnualCoverPriceToPayCancellationOutput;
//# sourceMappingURL=AnnualCoverPriceToPayCancellationOutput.js.map